import * as React from 'react';
import styled from 'styled-components'

interface IProps
    extends React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
}

const AvatarSmallDefault: React.SFC<IProps> = (props) => {

    const { ...ImgProps } = props;

    return (<img {...ImgProps} />)

};

const AvatarSmall = styled(AvatarSmallDefault)`
    width: 36px;
    height: 36px;
    border-radius: 50%; 
    object-fit: cover;
`;

export default AvatarSmall;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/avatar/avatar_small.tsx